
  import {Component, Vue} from "vue-property-decorator";
  import {ANONYMOUS_PAGE} from "@/modules/Auth/stores/auth.store";
  import {IReport} from "@/modules/Report/interfaces/report.interface";
  import {IBus} from "@/interfaces/bus-actions";
  import {bus} from "@/plugins/bus";
  import {IApp} from "@/interfaces/app.interface";
  import {isMobileOnly} from "mobile-device-detect";
  import {IAuth} from "@/modules/Auth/interfaces/auth.interface";

  @Component({})
  export default class AppMenuItemReport extends Vue {

    collapseValue = null;
    reportName = IReport.ReportName;
    isMobileOnly;

    get easyModeInterface() { return !this.$store.state.auth.userAccess.extModeFlag; }
    get userAccess(): IAuth.UserAccess { return this.$store.state.auth.userAccess; }
    get isUser() { return this.$store.state.auth.isUser; }
    get anonymous() { return this.$store.state.route.query[ANONYMOUS_PAGE] ? JSON.parse(this.$store.state.route.query[ANONYMOUS_PAGE]) : false; }

    get listLinks() {
      let list = [
        {
          label: 'Движение',
          name: this.reportName.Movement,
          icon: 'truck',
          displayCondition: true,
        }, {
          label: 'Дашборд',
          name: 'Dashboard',
          icon: 'chart-simple',
          displayCondition: this.isUser && !this.anonymous && this.userAccess && this.userAccess.scDashBoard,
        }, {
          label: 'Общий баланс',
          name: this.reportName.Balance,
          icon: 'file-lines',
          displayCondition: !this.isMobileOnly && this.userAccess && this.userAccess.scRptBalance,
        }, {
          label: 'Баланс счета',
          name: 'BalancePopup',
          icon: 'file-lines',
          displayCondition: !this.userAccess.disableBalance,
        }, {
          label: 'События',
          name: this.reportName.Events,
          icon: 'file-lines',
          displayCondition: !this.isMobileOnly && this.userAccess && this.userAccess.scRptEvents
        }, {
          label: 'Сводная по машинам',
          name: this.reportName.Cars,
          icon: 'file-lines',
          displayCondition: !this.isMobileOnly && this.userAccess && this.userAccess.scRptCarsSvod,
        }, {
          label: 'Баланс по машинам',
          name: this.reportName.CarsBalance,
          icon: 'file-lines',
          displayCondition: !this.isMobileOnly && this.userAccess && this.userAccess.scRptCarsBalance,
        }, {
          label: 'Сводная по парковке',
          name: this.reportName.Parks,
          icon: 'square-parking',
          displayCondition: !this.isMobileOnly && this.userAccess && this.userAccess.scRptSvodParks,
        }, {
          label: 'Отчет агента',
          name: this.reportName.Agent,
          icon: 'glasses',
          displayCondition: this.userAccess && this.userAccess.scRptAgent,
        },
      ];
      return list;
    }

    created() {
      this.isMobileOnly = isMobileOnly;
    }

    async openReport(report) {
      this.collapseValue = null;
      bus.$emit(IBus.AppMenuAction.Close);

      if (report === 'BalancePopup') {
        await this.$store.dispatch('dialog/openDialog', { blockName: 'payment', dialogName: 'balancePopup' });
      }
      else if (report === 'Dashboard') {
        await this.$store.dispatch('openPage', { routeName: IApp.ROUTE_NAME.PAGE_DASHBOARD, query: this.$route.query });
      }
      else {
        let reportPages = {
          [IReport.ReportName.Balance]: IApp.ROUTE_NAME.PAGE_REPORT_BALANCE,
          [IReport.ReportName.Events]: IApp.ROUTE_NAME.PAGE_REPORT_EVENTS,
          [IReport.ReportName.Movement]: IApp.ROUTE_NAME.PAGE_REPORT_MOVEMENTS,
          [IReport.ReportName.Cars]: IApp.ROUTE_NAME.PAGE_REPORT_CARS,
          [IReport.ReportName.CarsBalance]: IApp.ROUTE_NAME.PAGE_REPORT_CARS_BALANCE,
          [IReport.ReportName.Parks]: IApp.ROUTE_NAME.PAGE_REPORT_PARKS,
          [IReport.ReportName.Agent]: IApp.ROUTE_NAME.PAGE_REPORT_AGENT,
        };

        await this.$store.dispatch('openPage', {routeName: reportPages[report]});
      }
    }
  }
